import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Belt from "../page-components/package-details/Belt";
import ImpInfo from "../page-components/package-details/ImpInfo";
import Itinary from "../page-components/package-details/Itinary";
import Overview from "../page-components/package-details/Overview";
import { useInView } from "react-intersection-observer";
import ReviewCard from "../cards/ReviewCard";
import { IPackage, IReviewsList } from "../../types/global";
import PhotoGallery from "../page-components/package-details/PhotoGallery";
// import TestReponsive from "../page-essentials/TestReponsive";
import BookNowCard from "../page-components/package-details/BookNowCard";
import LangContext from "../../context/LangContext";
import PackagesService from "../../services/Packages.service";
import ReviewService from "../../services/Review.service";
import WhyToBookCard from "../cards/WhyToBookCard";

const PackageDetails: React.FC = () => {
  const pkgId = useSearchParams()[0].get("pkg");
  const [reviewData, setReviewData] = useState<IReviewsList[]>([]);

  const { ref: overviewRef, inView: myOverviewElementIsVisible } = useInView({
    threshold: 0.45,
  });
  const { ref: impInfoRef, inView: myImpElementIsVisible } = useInView({
    threshold: 0.45,
  });
  const { ref: itinaryRef, inView: myItinaryElementIsVisible } = useInView({
    threshold: 0.45,
  });
  const { ref: reviewRef, inView: myReviewElementIsVisible } = useInView({
    threshold: 0.45,
  });
  // const { ref: itinaryRef, inView: myElementIsVisible } = useInView()

  const [activeTab, setActiveTab] = useState("");
  const [scrollActive, setScrollActive] = useState(false);
  const { lang_id } = useContext(LangContext);

  const createScrollNavEffect = () => {
    if (window.scrollY >= 1152) {
      setScrollActive(true);
      console.log(window.scrollY);
      return;
    } else {
      setScrollActive(false);
      return;
    }
  };
  window.addEventListener("scroll", createScrollNavEffect);

  const [pkgDetailData, setPkgDetailData] = useState<IPackage>();

  const fetchPkgDetails = async (pkggId: string) => {
    try {
      const res = await PackagesService.fetchPackageDetails(pkggId, lang_id);
      setPkgDetailData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPkgReviews = async (pkgId: string) => {
    try {
      const res = await ReviewService.fetchReviews(`?pkg=${pkgId}`);
      setReviewData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    createScrollNavEffect();
    if (pkgId && lang_id) {
      fetchPkgDetails(pkgId);
      fetchPkgReviews(pkgId);
    }
  }, [pkgId, lang_id]);

  return (
    <div>
      {/* <TestReponsive /> */}
      {/* nav belt section */}
      <Belt
        img={`${process.env.REACT_APP_API}/uploads/images/${pkgDetailData?.package_img}`}
        pkg={`${pkgDetailData?.translation[0].package_title}`}
      />

      {/* package summary card section  */}
      <div className="container mx-auto bg-white -mt-20 shadow-lg relative p-4 py-8 rounded-lg">
        <h1 className="text-lg font-medium text-center mt-3 mb-8">
          Package Summary
        </h1>
        <div className="flex items-center space-x-4 lg:space-x-8 justify-center w-full px-5 lg:w-2/3 mx-auto flex-wrap gap-y-8">
          {pkgDetailData?.translation[0].package_summary
            .split(",")
            .map((item, i) => (
              <ul key={i} className=" flex items-center space-x-2">
                <span className="block h-3 w-3 bg-primary-base"></span>
                <li className="capitalize"> {item}</li>
              </ul>
            ))}
        </div>
        {/* <div className="flex divide-x justify-center gap-8 flex-wrap">
          {pkgDetailData?.pkgAmenities.map((item, i) => (
            <div className=" p-3 text-center px-12 space-y-5">
              <img
                src={`${process.env.REACT_APP_API}/uploads/images/${item.amenity_icon}`}
                alt={item.amenity}
                className="h-12 w-12 object-cover text-center mx-auto"
              />
              <p>{item.amenity}</p>
            </div>
          ))}
        </div> */}
      </div>

      {/* tabs section  */}
      <div
        className={`${
          scrollActive
            ? "bg-white pt-4 h-fit py-2 shadow-lg animate-from-top fixed top-[6%] lg:top-[9%] w-full z-10"
            : "hidden animate-to-top w-full h-20"
        }`}
      >
        <div className="container mx-auto px-4 xl:px-8  ">
          {/* upper section  */}
          {/* <div className="flex justify-between items-center">
                        <p>Gurantted Departure</p>
                        <div className="flex items-center space-x-3">
                            <h1 className="font-semibold text-lg capitalize">{pkg} </h1>
                            <div className="bg-primary-base px-2 py-1 text-white w-fit font-medium">
                                <p>2D | 3N</p>
                            </div>
                        </div>

                    </div> */}

          {/* <hr className="mb-2" /> */}
          {/* lower section  */}
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center gap-x-3 gap-y-2 md:space-x-4 xl:space-x-7 flex-wrap">
              <a href="#overview">
                <p
                  className={` ${
                    myOverviewElementIsVisible
                      ? "font-medium border-b-2 border-b-primary-base pb-2"
                      : "pb-2 cursor-pointer"
                  }`}
                  onClick={() => setActiveTab("about")}
                >
                  About
                </p>
              </a>
              <a href="#impInfo">
                <p
                  className={` ${
                    myImpElementIsVisible
                      ? "font-medium border-b-2 border-b-primary-base pb-2"
                      : "pb-2 cursor-pointer"
                  }`}
                  onClick={() => setActiveTab("impInfo")}
                >
                  Important Information
                </p>
              </a>
              <a href="#itinary">
                <p
                  className={` ${
                    myItinaryElementIsVisible
                      ? "font-medium border-b-2 border-b-primary-base pb-2"
                      : "pb-2 cursor-pointer scroll-mt-80"
                  }`}
                  onClick={() => setActiveTab("itinary")}
                >
                  Itinary
                </p>
              </a>

              <a href="#reviews">
                <p
                  className={`${
                    myReviewElementIsVisible
                      ? "font-medium border-b-2 border-b-primary-base pb-2"
                      : "pb-2 cursor-pointer scroll-mt-80"
                  }`}
                  onClick={() => setActiveTab("reviews")}
                >
                  Reviews
                </p>
              </a>
              <button className="block md:hidden bg-optional px-4 py-2 text-white font-semibold rounded-full flex-1">
                Start Booking Process
              </button>
            </div>
            {/* right section  */}
          </div>
        </div>
      </div>
      {/* tabs section ends  */}

      {/* trekking overview section  */}
      <div className="container mx-auto px-4 2xl:px-8 lg:grid grid-cols-12 gap-4 xl:gap-8">
        {/* left side  */}
        <div className="col-span-8">
          <div className="my-12 scroll-mt-32" id="overview" ref={overviewRef}>
            <Overview overview={pkgDetailData?.translation[0].overview!} />
          </div>

          {/* trekking important information section  */}
          <div
            className="container mx-auto px-4 2xl:px-8 my-6 scroll-mt-48"
            id="impInfo"
            ref={impInfoRef}
          >
            <ImpInfo impInfo={pkgDetailData?.translation[0].imp_info!} />
          </div>

          {/* trekking itinary section  */}
          <div
            className="container mx-auto px-4 2xl:px-8 my-6 scroll-mt-48"
            id="itinary"
            ref={itinaryRef}
          >
            <Itinary itinary={pkgDetailData?.translation[0].itinary!} />
          </div>

          {/* for responsive design  */}
          <div className="container mx-auto px-4">
            <div className="my-4 block lg:hidden">
              <PhotoGallery />
            </div>

            <div className="my-4 md:my-12 md:w-full block lg:hidden">
              {pkgDetailData && (
                <BookNowCard
                  pkg_id={pkgDetailData?.id}
                  title={pkgDetailData?.translation[0].package_title}
                  price={pkgDetailData?.starting_price}
                />
              )}
              <div className="shadow-lg p-8 mt-5">
                <WhyToBookCard />
              </div>
            </div>
          </div>
        </div>

        {/* right side  */}
        <div className="col-span-4 relative">
          <div className="mt-24 relative">
            {/* TODO: */}
            <img
              src={`${process.env.REACT_APP_API}/uploads/images/${pkgDetailData?.package_img}`}
              alt=""
              srcSet=""
              className="rounded-lg"
            />
            <div className="hidden lg:block">
              <PhotoGallery />
            </div>
          </div>
          <div className="my-4 hidden lg:block sticky top-48 ">
            {pkgDetailData && (
              <BookNowCard
                pkg_id={pkgDetailData?.id}
                title={pkgDetailData?.translation[0].package_title}
                price={pkgDetailData?.starting_price}
              />
            )}
            <div className="shadow-lg p-8 mt-5">
              <WhyToBookCard />
            </div>
          </div>
        </div>
      </div>

      <div
        className="container mx-auto px-4 2xl:px-8 my-6 scroll-mt-48"
        id="reviews"
        ref={reviewRef}
      >
        <h1 className="text-2xl font-semibold mt-16 text-primary-base">
          Tour Reviews
        </h1>
        {reviewData.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 h-full  mt-4 ">
            {reviewData.map((item, i) => (
              <ReviewCard
                key={i}
                reviewType={item.review_category.review_category_name}
                data={{
                  reviewHighlight: item.review_headline,
                  img: item.user_img,
                  location: item.address,
                  name: item.name,
                  review: item.message,
                  stars: item.rating,
                }}
                reviewRef={reviewRef}
              />
            ))}
          </div>
        ) : (
          <div className="bg-gray-100 p-4 my-5 w-full">No records found!</div>
        )}
      </div>
    </div>
  );
};

export default PackageDetails;
